import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import getRecsSessionValue from '@tvg/recs-get-session';

const Container = styled.div``;
const DividerDiv = styled.div`
  padding: 0 0 0 0;
`;
const BorderDiv = styled.div`
  border-top: 1px solid var(--color-global-grey400);
  padding: var(--spacing-space32) 0 0 0;
`;

type Props = {
  hideBorder?: boolean;
};

function Recommendations(props: Props) {
  const { hideBorder = false } = props;
  const [esiLoaded, setEsiLoaded] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const divExists = document.querySelector('[data-testid="recommendations-carousel"]') !== null;
      if (divExists) {
        getRecsSessionValue();
        setEsiLoaded(true); // Set the state variable to true to render the ESI fragment
        clearInterval(interval); // Stop the interval once the div exists
      }
    }, 500);

    // After n seconds stop the initial checking if the ESI exists
    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 15000);

    // clean up interval & timeout when component unmounts
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [esiLoaded]);

  return (
    <Container>
      {esiLoaded && hideBorder && <DividerDiv data-testid="recs-divider" />}
      {esiLoaded && !hideBorder && <BorderDiv data-testid="recs-border-divider" />}
      <Container
        dangerouslySetInnerHTML={{
          __html: `
              <esi:include src="/fragment/prdi-recommendations-fe/recommendations/recs2/pdp_1" />
              <esi:include src="/fragment/prdi-recommendations-fe/recommendations/recs2/pdp_2" />`,
        }}
      />
    </Container>
  );
}

export default Recommendations;
